(()=>{
  const link=document.querySelector('[data-wvck-cart]');
  if(!link||link.dataset.cartReady)return;
  link.dataset.cartReady='true';
  const url=new URL(link.href,location.href),badge=link.querySelector('[data-cart-count]');
  // A Shopify cart belongs to the visitor's session on the store's origin.
  if(url.origin!==location.origin)return;
  let busy=false;
  async function refresh(){
    if(busy||document.hidden)return;
    busy=true;const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),8000);
    try{
      const response=await fetch(url.pathname.replace(/\/$/,'')+'.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:controller.signal});
      if(!response.ok)throw new Error('Cart unavailable');
      const cart=await response.json();
      if(!Number.isInteger(cart.item_count)||cart.item_count<0)throw new Error('Invalid cart');
      badge.textContent=String(cart.item_count);badge.hidden=false;
      link.setAttribute('aria-label','Open cart, '+cart.item_count+' '+(cart.item_count===1?'item':'items'));
    }catch(error){/* Keep the server-rendered count and working cart link. */}
    finally{clearTimeout(timer);busy=false;}
  }
  window.addEventListener('pageshow',refresh);
  window.addEventListener('focus',refresh);
  document.addEventListener('visibilitychange',refresh);
  ['shopify:cart:lines-update','cart:updated','cart:refresh'].forEach(name=>document.addEventListener(name,refresh));
  setInterval(refresh,30000);
  refresh();
})();
